export const SHOPIFY_QUERY_PARAM_KEYS = [
  "spjwt",
  "token",
  "host",
  "embedded",
  "shop",
  "apiKey",
];

export const pickShopifyParams = (params = {}) =>
  SHOPIFY_QUERY_PARAM_KEYS.reduce((acc, key) => {
    const value = params?.[key];

    if (value !== undefined && value !== null && value !== "") {
      acc[key] = value;
    }

    return acc;
  }, {});

const isInternalAppPath = (path) =>
  typeof path === "string" && path.startsWith("/") && !path.startsWith("//");

export const appendShopifyParams = (path, shopifyParams = {}) => {
  if (
    !path ||
    !isInternalAppPath(path) ||
    !shopifyParams ||
    !Object.keys(shopifyParams).length
  ) {
    return path;
  }

  const [pathWithoutHash, hash = ""] = path.split("#");
  const [pathname, existingSearch = ""] = pathWithoutHash.split("?");
  const searchParams = new URLSearchParams(existingSearch);

  SHOPIFY_QUERY_PARAM_KEYS.forEach((key) => {
    const value = shopifyParams[key];

    if (value !== undefined && value !== null && value !== "") {
      searchParams.set(key, value);
    }
  });

  const queryString = searchParams.toString();
  const nextPath = queryString ? `${pathname}?${queryString}` : pathname;

  return hash ? `${nextPath}#${hash}` : nextPath;
};

export const mergeShopifyParams = (...sources) =>
  sources.reduce(
    (merged, source) => ({
      ...merged,
      ...pickShopifyParams(source),
    }),
    {},
  );
